import { MenuProps } from "@/layout/Navbar/Side/SideDrawer";

export const mainTentangKamiNavMenus: MenuProps[] = [
  {
    title: "Fasilitas",
    anchor: "listItemFasilitas"
  },
  {
    title: "Tata Tertib",
    path: "/tata-tertib"
  },
  {
    title: "Struktur Organisasi",
    path: "/str-org"
  }
];